import {Platform} from 'quasar';

class Sound {
	audioContext: AudioContext | null = null;

	constructor() {
		window.addEventListener('touchstart', this.setupAudio.bind(this), {
			passive: true
		});
		window.addEventListener('click', this.setupAudio.bind(this), {
			passive: true
		});
	}

	setupAudio() {
		if(this.audioContext) {
			return;
		}
		// Need to set this up on user-interaction so we can play a sound later
		// specifically on iOS
		this.audioContext = new AudioContext();

		const source = this.audioContext.createBufferSource();
		source.buffer = this.audioContext.createBuffer(1, 1, 22050);
		source.connect(this.audioContext.destination);

		source.start(0);

		window.removeEventListener('touchstart', this.setupAudio.bind(this));
		window.removeEventListener('click', this.setupAudio.bind(this));
	}

	async playOrderReadySound() {
		if(Platform.is.capacitor && !this.audioContext) {
			// On native, we don't need to wait for user interaction
			this.setupAudio();
		}
		if(this.audioContext) {
			try {
				const result = await fetch('/sounds/order-ready.m4a');
				const arrayBuffer = await result.arrayBuffer();
				const buffer = await this.audioContext.decodeAudioData(arrayBuffer);

				const source = this.audioContext.createBufferSource();
				source.buffer = buffer;
				source.connect(this.audioContext.destination);
				source.start(0);
			} catch(e) {
				console.log('Failed to play sound', e);
			}
		} else {
			console.error('Audio not setup');
		}
	}
}


export const SoundService = new Sound();

